// @flow

// eslint-disable-next-line id-blacklist
module.exports = function noop() {};
